export default __webpack_public_path__ + "assets/fonts/329a95a9172fdb2cccb4f9347ed55233.woff";